import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LockerModel } from '../../models/locker-model';
import { PriceModel } from '../../models/price-model';
import { AppService } from '../app/app.service';
import { ConfigModel } from 'app/models/config-model';
import { UserDetailsModel } from 'app/models/user';
import { ProductModel } from 'app/models/product-model';
import { ReservationModel } from 'app/models/reservation-model';
import { Constants } from 'app/components/utils/Constants';
import { ChangePassword } from 'app/models/changePassword';
import { DiscountModel } from 'app/models/discount-model';
import { JobParamenterModel } from 'app/models/job-parameter-model';
import { TextContentModel } from 'app/models/text-content-model';
import { Cart } from 'app/models/cart-model';
import { UserFiscalDataModel } from 'app/models/user-fiscal-data-model';
import { StockDetailRequestModel } from 'app/models/stock-detail-request-model';
import { ChangeTokenPassword } from 'app/models/change-token-password';
import { DataTicketModel } from 'app/models/data-ticket-model';
import { DatasetQueryRequestModel } from 'app/models/dataset-query-request-model';
import { CompanyModel } from 'app/models/company-model';
import { ReservationDetailsDto } from 'app/models/reservation-details-model';

@Injectable({
  providedIn: 'root'
})
export class RestService {

    constructor(
        private http: HttpClient,
        private appService: AppService) {
                    
    }


    //USADOS
    getConfigurations(): Observable<any> {
        return this.http.get(this.appService.servidor+'/configurations');
    }
    getLocation(locationCode:string): Observable<any> {
        return this.http.get(this.appService.servidor+'/reserve/locations/'+locationCode);
    }
    searchCompanies(): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/companies');
    }
    createCompany(company: CompanyModel): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/companies', company);
    }
    putCompany(company: any): Observable<any> {
        return this.http.put(this.appService.servidor+'/admin/companies/'+company.id, company);
    }
    imageCompany(id: number, form: FormData): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/companies/${id}/image`, form);
    }
    deleteCompany(id: number): Observable<any> {
        return this.http.delete(this.appService.servidor+'/admin/companies/'+id);
    }
    searchUsers(filters:string): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/users/search?'+filters);
    }
    getUser(id:number): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/users/'+id);
    }
    postUser(user: UserDetailsModel): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/users', user);
    }
    putUser(user: UserDetailsModel): Observable<any> {
        return this.http.put(this.appService.servidor+'/admin/users/'+user.id, user);
    }
    deleteUser(id: number): Observable<any> {
        return this.http.delete(this.appService.servidor+'/admin/users/'+id);
    }
    deleteCompanyData(id: number): Observable<any> {
        return this.http.delete(this.appService.servidor+'/admin/users/customer/'+id);
    }
    changePassword(changePassword: ChangePassword): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/changePassword', changePassword);
    }
    getProducts(): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/products');
    }
    postProduct(product: ProductModel): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/products', product);
    }
    putProduct(product: ProductModel): Observable<any> {
        return this.http.put(this.appService.servidor+'/admin/products/'+product.id, product);
    }
    deteleProduct(productId: number): Observable<any> {
        return this.http.delete(this.appService.servidor+'/admin/products/'+productId);
    }
    lockerOpenManual(id: number): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/boxes/${id}/openCloseLocker`);
    }
    boxesCleaning(lockerType: string): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/boxes/boxesCleaning/'+lockerType, {});
    }
    searchBoxes(filters:string): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/boxes/search?${filters}`);
    }
    getLockersByProductId(producId: number): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/lockerByProductId/'+producId);
    }
    getLockersByTypeAndSize(typeId: string, sizeId: string): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/lockerByTypeAndSize/'+typeId+'/'+sizeId);
    }
    postLockers(locker: LockerModel): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/boxes', locker);
    }
    putLockers(locker: LockerModel): Observable<any> {
        return this.http.put(this.appService.servidor+'/admin/boxes/'+locker.id, locker);
    }
    deteleLocker(lockerId: number): Observable<any> {
        return this.http.delete(this.appService.servidor+'/admin/boxes/'+lockerId);
    }
    getCategories(): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/categories');
    }
    createCategory(category: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/categories', category);
    }
    putCategory(category: any): Observable<any> {
        return this.http.put(this.appService.servidor+'/admin/categories/'+category.id, category);
    }
    imageCategory(id: number, form: FormData): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/categories/${id}/image`, form);
    }
    deleteCategory(categoryId: number): Observable<any> {
        return this.http.delete(this.appService.servidor+'/admin/categories/'+categoryId);
    }
    getOrdersMerged(parameters: string): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/reservations?'+parameters);
    }
    getReservation(uuid: string): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/reservations/${uuid}`);
    }
    syncReservation(uuid: string): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/reservations/${uuid}/sync`, false);
    }
    snapshotReservation(uuid: string): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/reservations/${uuid}/sync`, true);
    }
    //getOrdersServer(parameters: string): Observable<any> {
    //    return this.http.get(this.appService.servidor+'/admin/orders/server?'+parameters);
    //}
    //getOrdersLockerApp(): Observable<any> {
    //    return this.http.get(this.appService.servidor+'/admin/orders/lockerApp');
    //}
    //getOrderLockerApp(uuid: string): Observable<any> {
    //    return this.http.get(`${this.appService.servidor}/admin/orders/${uuid}/lockerApp`);
    //}
    createOrder(cart: Cart): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/reservations', cart);
    }
    updateOrder(reservation: ReservationDetailsDto): Observable<any> {
        return this.http.put(this.appService.servidor+'/admin/reservations/'+reservation.uuid, reservation);
    }
    reopenReserve(uuid: string): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/reservations/${uuid}/reopen`, {});
    }
    changePasswordOrder(uuid: string, passowds:any): Observable<any> {
        return this.http.post(this.appService.servidor+'/user/reserves/changePin/'+uuid, passowds);
    }
    changeBoxOrder(uuid: string, boxId:number): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/reservations/${uuid}/changeBox`, boxId);
    }
    updateEmailReservation(uuid:string, email:string): Observable<any> {
        return this.http.put(this.appService.servidor+`/admin/reservations/${uuid}/changeEmail`, email);
    }
    updatePhoneReservation(uuid:string, email:string): Observable<any> {
        return this.http.put(this.appService.servidor+`/admin/reservations/${uuid}/changePhone`, email);
    }
    createTrack(reservation: ReservationModel, withInvoice: boolean): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/track?withInvoice='+withInvoice, reservation);
    }
    closeOrder(uuid: string): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/reservations/${uuid}/close`, {});
    }
    getTracks(uuid: string[]): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/reservations/${uuid}/tracks`, {context: new HttpContext().set(Constants.SPINNER, false)});
    }
    calculatePeriods(uuid: string): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/reservations/${uuid}/calculatePeriods`, {context: new HttpContext().set(Constants.SPINNER, false)});
    }
    searchPayments(params?:any): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/payments/search?${params}`);
    }
    getPayment(paymentUuid:string): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/payments/${paymentUuid}`);
    }
    getResumenPayments(params?:any): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/payments/summary?${params}`);
    }
    getTicketBase64(paymentUuid:string, ticketNumber: string): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/payments/${paymentUuid}/tickets/${ticketNumber}/file`);
    }
    getPaymentReport(params?: any): Observable<Blob> {
        return this.http.get(`${this.appService.servidor}/admin/payments/report?${params}`, { responseType: 'blob' });
    }
    //Invoice
    searchInvoices(params?:any): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/invoices/search?${params}`);
    }
    getInvoice(invoiceNumber:string): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/invoices/${invoiceNumber}`);
    }
    getResumenInvoices(params?:any): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/invoices/summary?${params}`);
    }
    getInvoiceBase64(invoiceNumber: string): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/invoices/${invoiceNumber}/file`);
    }
    getInvoiceBase64User(invoiceNumber: string): Observable<any> {
        return this.http.get(`${this.appService.servidor}/user/invoice/download/${invoiceNumber}`);
    }
    getInvoiceReport(params?:any): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/invoices/report?${params}`, {responseType: 'blob' as 'json'});
    }
    getInvoiceZip(params?:any): Observable<any> {
        const headers = new HttpHeaders({'Content-Type': 'application/zip; charset=utf-8','Accept': 'application/octet-stream'});
        return this.http.get(`${this.appService.servidor}/admin/invoices/file?${params}`, { headers, responseType: 'blob' });
    }
    convertInvoice(paymentUuid:string, invoiceNumber:string, userId:number): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/payments/${paymentUuid}/invoices/${invoiceNumber}/conversion/${userId}`, {});
    }
    getPrices(): Observable<any> {//TODO revisar en product
        return this.http.get(this.appService.servidor+'/admin/prices');
    }
    getPools(): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/pools');
    }
    requestPool(): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/pools/request', {});
    }
    consumePool(id:number): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/pools/'+id+'/consume', {});
    }
    consumeItemPool(poolId:number, itemId:number): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/pools/${poolId}/items/${itemId}/consume`, {});
    }
    getDiscounts(): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/discounts');
    }
    postDiscount(discount: DiscountModel): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/discounts', discount);
    }
    putDiscount(discount: DiscountModel): Observable<any> {
        return this.http.put(this.appService.servidor+'/admin/discounts/'+discount.id, discount);
    }
    deleteDiscount(discountId: string): Observable<any> {
        return this.http.delete(this.appService.servidor+'/admin/discounts/'+discountId);
    }
    getSenderEmails(parameter: string): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/senders/email?'+parameter);
    }
    getSenderSMSs(parameter: string): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/senders/sms?'+parameter);
    }
    resendEmail(orderUuid: any): Observable<any> {
        return this.http.get(this.appService.servidor+'/reserve/resendEmail/'+orderUuid);
    }
    getConfigs(): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/configs');
    }
    postConfig(config: ConfigModel): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/configs', config);
    }
    putConfig(config: ConfigModel): Observable<any> {
        return this.http.put(this.appService.servidor+'/admin/configs/'+config.id, config);
    }
    deleteConfig(config: ConfigModel): Observable<any> {
        return this.http.delete(this.appService.servidor+'/admin/configs/'+config.id);
    }
    getLiterals(parameters: string): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/literals?'+parameters);
    }
    createLiteral(textContent: TextContentModel): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/literal', textContent);
    }
    updateLiteral(textContent: TextContentModel): Observable<any> {
        return this.http.put(this.appService.servidor+'/admin/literal', textContent);
    }
    deleteLiteral(textContentId: number): Observable<any> {
        return this.http.delete(this.appService.servidor+'/admin/literal/'+textContentId);
    }
    getActivities(orderUuid: string): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/activity/'+orderUuid);
    }
    executeSync(direction: string, data:any): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/executeSync/'+direction, data);
    }
    reservationErase(): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/kiosk/reservationErase', {});
    }
    sendAction(action: any, param: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/locker/action/'+action, param);
    }
    dataExample(): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/dataExample');
    }
    findClientLocker(): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/findClientLocker');
    }
    findFreeLocker(): Observable<any> {
        return this.http.get(this.appService.servidor+'/reserve/stock', {context: new HttpContext().set(Constants.SPINNER, false)});
    }
    getProfile(): Observable<any> {
        return this.http.get(this.appService.servidor+'/user/profile', {context: new HttpContext().set(Constants.REDIRECT, false)});
    }
    updateProfile(profile: any): Observable<any> {
        return this.http.post<any>(this.appService.servidor+'/user/profile', profile);
    }
    login(form: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/auth/signin', form);
    }
    registro(form: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/auth/signup', form);
    }
    forgotPassword(email: string, tenantId?: number): Observable<any> {
        const query = tenantId ? `?tenantId=${tenantId}` : '';
        return this.http.get(this.appService.servidor+'/auth/user/forgotPassword/'+email+query);
    }
    resetPassword(changeTokenPassword: ChangeTokenPassword): Observable<any> {
        return this.http.post(this.appService.servidor+'/auth/user/resetPassword', changeTokenPassword);
    }
    loginAs(username: string): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/loginAs/'+username, {});
    }
    checkoutCardStripe(cartRequest: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/payment/checkout/card/stripe', cartRequest);
    }
    
    checkoutCardMypost(cartRequest: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/payment/checkout/card/mypos', cartRequest);
    }
    
    checkoutCardPaypal(cartRequest: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/payment/checkout/card/paypal', cartRequest);
    }

    cancelCheckoutCard(paymentUuid: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/payment/checkout/card/cancel/'+paymentUuid, {});
    }

    cancelSubscription(paymentUuid: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/payment/checkout/subscription/cancel/'+paymentUuid, {});
    }
    
    calculatorStep2(stockDetailRequestModel: StockDetailRequestModel): Observable<any> {
        return this.http.post(this.appService.servidor+'/reserve/calculator/step2', stockDetailRequestModel, {context: new HttpContext().set(Constants.SPINNER, false)});
    }

    calculatorStep3(stockDetailRequestModel: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/reserve/calculator/step3', stockDetailRequestModel, {context: new HttpContext().set(Constants.SPINNER, false)});
    }

    infoCart(cartRequest: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/reserve/infocart', cartRequest);
    }

    getResumenOnline(paymentUuid: string): Observable<any> {
        return this.http.get(this.appService.servidor+'/reserve/getResumenOnline/' + paymentUuid, {context: new HttpContext().set(Constants.SPINNER, false)});
    }

    validateDiscount(cartRequest: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/payment/validateDiscount', cartRequest);
    }

    sendEmailContact(form: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/guest/contact/email', form);
    }
        
    getJobs(): Observable<any> {
        return this.http.get(this.appService.servidor+'/schedule/jobs');
    }
    createJob(jobParamenter: JobParamenterModel): Observable<any> {
        return this.http.post(this.appService.servidor+`/schedule/schedule?jobName=${jobParamenter.jobName}&cronExpression=${jobParamenter.cronExpression}&jobScheduleTime=${jobParamenter.jobScheduleTime}`, {});
    }
    updateJob(jobParamenter: JobParamenterModel): Observable<any> {
        return this.http.post(this.appService.servidor+`/schedule/update?jobName=${jobParamenter.jobName}&cronExpression=${jobParamenter.cronExpression}&jobScheduleTime=${jobParamenter.jobScheduleTime}`, {});
    }
    deleteJob(jobParamenter: JobParamenterModel): Observable<any> {
        return this.http.post(this.appService.servidor+`/schedule/delete?jobName=${jobParamenter.jobName}`, {});
    }
    unscheduleJob(jobParamenter: JobParamenterModel): Observable<any> {
        return this.http.post(this.appService.servidor+`/schedule/unschedule?jobName=${jobParamenter.jobName}`, {});
    }
    pauseJob(jobParamenter: JobParamenterModel): Observable<any> {
        return this.http.post(this.appService.servidor+`/schedule/pause?jobName=${jobParamenter.jobName}`, {});
    }
    resumeJob(jobParamenter: JobParamenterModel): Observable<any> {
        return this.http.post(
            this.appService.servidor+`/schedule/resume?jobName=${jobParamenter.jobName}`, {});
    }
    checkJobNameJob(jobParamenter: JobParamenterModel): Observable<any> {
        return this.http.post(this.appService.servidor+`/schedule/checkJobName?jobName=${jobParamenter.jobName}`, {});
    }
    isJobRunningJob(jobParamenter: JobParamenterModel): Observable<any> {
        return this.http.post(this.appService.servidor+`/schedule/isJobRunning?jobName=${jobParamenter.jobName}`, {});
    }
    jobStateJob(jobParamenter: JobParamenterModel): Observable<any> {
        return this.http.post(this.appService.servidor+`/schedule/jobState?jobName=${jobParamenter.jobName}`, {});
    }
    stopJob(jobParamenter: JobParamenterModel): Observable<any> {
        return this.http.post(this.appService.servidor+`/schedule/stop?jobName=${jobParamenter.jobName}`, {});
    }
    startJob(jobParamenter: JobParamenterModel): Observable<any> {
        return this.http.post(this.appService.servidor+`/schedule/start?jobName=${jobParamenter.jobName}`, {});
    }
    getCronNames(): Observable<any> {
        return this.http.get(this.appService.servidor+'/schedule/methodCron');
    }
    getPaymentProviders(page: number = 0, size: number = 10): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/paymentprovider?sort=updatedAt,desc&page=${page}&size=${size}`);
    }
    getWorkerManager(filters:string): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/workerManager/search?${filters}`);
    }
    resetWorkerManager(id:number): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/workerManager/reset/'+id);
    }
    getPendingEvents(page: number = 0, size: number = 20): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/pendingEvent?sort=lastSentAt,desc&page=${page}&size=${size}`);
    }
    getPendingEvent(id: string): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/pendingEvent/${id}`);
    }
    getKioskSyncs(): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/kioskSync`);
    }
    getKioskSync(id: number): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/kioskSync/${id}`);
    }
    getAdminKioskDb(): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/kiosk/db`);
    }
    printTicket(paymentUuid:string, ticketUuid:string): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/payments/${paymentUuid}/ticket/${ticketUuid}/print`, {});
    }
    generateTicket(paymentUuid:string, ticketUuid:string, dataTicket:any): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/payments/${paymentUuid}/ticket/${ticketUuid}/generation`, dataTicket);
    }
    regenerateQrTicket(paymentUuid:string, ticketUuid:string): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/payments/${paymentUuid}/ticket/${ticketUuid}/regenerateQR`, {});
    }
    searchCustomer(filters:string): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/customer/search?'+filters);
    }
    createCustomer(userFiscalData:UserFiscalDataModel): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/customer', userFiscalData);
    }
    updateCustomer(userFiscalData:UserFiscalDataModel): Observable<any> {
        return this.http.put(this.appService.servidor+'/admin/customer/'+userFiscalData.id, userFiscalData);
    }
    deleteCustomer(id:number): Observable<any> {
        return this.http.delete(this.appService.servidor+'/admin/customer/'+id);
    }
    assingCustomer(paymentUuid:string, userId:number): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/payments/${paymentUuid}/assignee/${userId}`, {});
    }
    unassingCustomer(paymentUuid:string): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/payments/${paymentUuid}/unassigned`, {});
    }
    generateInvoive(paymentUuid:string): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/payments/${paymentUuid}/generateInvoice`, {});
    }
    paymentCancel(paymentUuid:string): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/payments/${paymentUuid}/cancellation`, {});
    }
    paymentCapture(paymentUuid:string): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/payments/${paymentUuid}/capture`, {});
    }
    getLoggers(filters:string): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/logger?'+filters);
    }
    redirection(url:string): Observable<any> {
        return this.http.get(this.appService.servidor+'/l/'+url);
    }
    analytics(datasetQueryRequestModel: DatasetQueryRequestModel): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/analytics/query', datasetQueryRequestModel);
    }
    dashboardAnalytics(): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/analytics/dashboard');
    }

}
